// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"8d035c11","234":"858e8262","453":"e2a347bd","517":"ed8f5de9","784":"52331182","889":"03c0fe3e"}[chunkId] + ".chunk.js";
};